<template>
  <div class="empty-list search-no-results">
    <h2 class="no-events-message">
      {{ i18n.t('calendars.near_events.no_events') }}
    </h2>
    <img class="marker-image hue-primary" src="../images/marker-large.png">
    <template v-if="showNewEventButton">
      <p class="mb10">
        {{ i18n.t('calendars.near_events.host_your_own_question') }}
      </p>
      <create-new-event-button class="action-button" text-i18n-key="calendars.show.new_event" />
    </template>
  </div>
</template>

<script>
import CreateNewEventButton from './create-new-event-button'
import { mapGetters } from 'vuex'

export default {
  components: {
    CreateNewEventButton
  },

  computed: {
    ...mapGetters(['newEventPath', 'showNewEventButton'])
  }
}
</script>

<style lang="scss" scoped>
.empty-list {
  padding: 20px;
  background-image: url('../images/aerial-map-background.png');
  background-color: #ECECEC;
  background-repeat: no-repeat;
  background-position: center top;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.no-events-message {
  max-width: 400px;
}

.marker-image {
  width: 30px;
}
</style>
